import { atom } from "jotai";

export const openedLabelIdState = atom<string | undefined>(undefined);
